import {AddMobileDeviceDialog} from "@/features/user/addMobileDeviceDialog";

export class AppOnboardingWidget extends HTMLElement {

	private addMobileDeviceDialog: AddMobileDeviceDialog;

	public connectedCallback(): void {
		this.innerHTML = `
				<div class="panel panel-flat">
					<div class="flex-row">
						<div class="flex-column-auto">
							<div class="panel-heading">
								<h4 class="panel-title">${messages["onboardingDashboard.app.title"]}</h4>
							</div>
							<div class="panel-body pt-0">
								<ul>
									${messages["onboardingDashboard.app.body"]}
								</ul>
								<div>
									${messages["onboardingDashboard.app.learnMore"]}
									<button class="btn btn-primary mt-20 ml-20" id="addMobileDeviceBtn">${messages["onboardingDashboard.app.useApp"]}</button>
								</div>
							</div>
						</div>
						<div class="flex-column">
							<div class="position-relative pull-right mt-20 mr-60">
								<img src="/timr/images/onboarding/app_back_${globals.language}.png" alt="iOS dashboard screen" height="170px">
								<img src="/timr/images/onboarding/app_front_${globals.language}.png" alt="iOS recording screen" height="170px" style="position: absolute;top: 27px;left: 40px;z-index: 1;">	
							</div>
						</div>
					</div>
				</div>`;
		this.querySelector("#addMobileDeviceBtn").addEventListener("click", () => this.openAddMobileDeviceDialog());
	}

	private openAddMobileDeviceDialog(): void {
		if (!this.addMobileDeviceDialog) {
			this.addMobileDeviceDialog = new AddMobileDeviceDialog();
		}
		this.addMobileDeviceDialog.open();
	}

}
